import {
  BarChartIcon,
  GridIcon,
  ActivityIcon,
  SettingsIcon,
  UserIcon,
} from '@newcore/icons';
import type { NavItem } from '@/types';

export const APP_CONFIG = {
  name: 'User Portal',
  description: 'Enterprise User Portal',
  version: '1.0.0',
};

export const ADMIN_CONSOLE_APP_NAME = 'Admin Console';

export const NAVIGATION_ITEMS: NavItem[] = [
  {
    title: 'Dashboard',
    href: '/dashboard',
    icon: GridIcon,
    active: true,
  },
  {
    title: 'Activity',
    href: '/activity',
    icon: ActivityIcon,
    active: false,
  },
  {
    title: 'Analytics',
    href: '/analytics',
    icon: BarChartIcon,
    active: false,
  },
  {
    title: 'Profile',
    href: '/profile',
    icon: UserIcon,
    active: false,
  },
  {
    title: 'Preferences',
    href: '/preferences',
    icon: SettingsIcon,
    active: false,
  },
];
